export const ErrorType = Object.freeze({
	// display the error dialog
	Normal: 'Normal',

	// display the error dialog only when the searchCritera matches in the error description
	Custom: 'Custom',

	// supress the error dialog
	Silent: 'Silent',
});
